import { render, staticRenderFns } from "./OrderManage.vue?vue&type=template&id=1b0ce60e&scoped=true"
import script from "./OrderManage.vue?vue&type=script&lang=js"
export * from "./OrderManage.vue?vue&type=script&lang=js"
import style0 from "./OrderManage.vue?vue&type=style&index=0&id=1b0ce60e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0ce60e",
  null
  
)

export default component.exports